import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgNoImage = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 29" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#979797"
      transform="translate(1 1)"
    >
      <path d="m4.43 26.702 9.16-14.044 5.086 7.532-4.119 6.512z" />
      <path d="M14.43 26.702 26.992 7.44 40 26.702z" />
      <circle cx={4.5} cy={4.5} r={4.5} />
    </g>
  </svg>
);
const Memo = memo(SvgNoImage);
export default Memo;
